import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { primaryCalculatorId } from '../../../core/reducers/financialCalculators';
import { useFetchCurrentVehiclePayment } from '../../../core/apiHooks/useFetchPayment';
import PriceComponent from '../../PriceComponent';
import useDynamicTooltip from '../../PriceComponent/useDynamicTooltip';
const priceComponentStyles = {
    priceStyles: {
        title: {
            size: 'extraSmall',
        },
        copy: {
            size: 'subheading',
        },
    },
    errorStyles: {
        container: {
            alignItems: 'center',
            gridColumn: '2',
            gridRow: '1',
            display: ['none', 'flex'],
        },
    },
};
const Price = ({ paymentData, shouldFetchPayment = true, calculatorId = primaryCalculatorId }) => {
    const { t } = useTranslation();
    // when payment data is passed in, disable fetching
    const defaultPaymentData = useFetchCurrentVehiclePayment(undefined, shouldFetchPayment);
    const { data, error, isFetching } = paymentData !== null && paymentData !== void 0 ? paymentData : defaultPaymentData;
    const { overrideShowSellingPrice, sellingPriceTooltipLabel } = useDynamicTooltip(calculatorId);
    const prices = {
        allInPrice: { ...data === null || data === void 0 ? void 0 : data.sellingPrice, label: t('Shared.Common.sellingPriceLabel') },
        msrpPrice: { ...data === null || data === void 0 ? void 0 : data.msrp, label: t('Shared.Common.msrpStartingFromLabel') },
    };
    return (_jsx(PriceComponent, { allInPriceTooltipLabel: sellingPriceTooltipLabel, errorMessage: t('Pages.Models.Exploration.contactLocalDealerLabel'), hasError: !!error, height: ['auto', 'auto', undefined], horizontalAlignment: "right", isFetching: isFetching, msrpStartingFromTooltipLabel: t('Shared.Common.msrpDisclaimerLabel'), priceComponentStyles: priceComponentStyles, prices: prices, overrideShowSellingPrice: overrideShowSellingPrice, alignItems: undefined, saveAboveLabel: undefined, suppressDiscount: undefined, showSellingPriceDisclaimer: undefined, errorIconName: "exclamationAlert", isLoadingIconLarge: true, loadingIconHeight: "28px", frieghtPDIFeesCost: undefined, dealerFee: undefined, showRebateDisclaimerIndicator: false }));
};
export default Price;
